import { createSlice } from "@reduxjs/toolkit";

const initialState:any = {
    contactObj: null,
    EmailContactObject:null,
    EmailContactObjectTask:null,
    ChatContactObject:null,
    consoleStorage:[],
};

const contactSlice = createSlice({
    name: "contactSlice",
    initialState: initialState,
    reducers: {
        setContactObject(state, action) {
            let payload = action.payload;
            state.contactObj = payload;
        },setEmailContactObject(state, action) {
            let payload = action.payload;
            state.EmailContactObject = payload;
        },setEmailContactObjectTask(state, action) {
            let payload = action.payload;
            state.EmailContactObjectTask = payload;
        },setChatContactObject(state, action) {
            let payload = action.payload;
            state.ChatContactObject = payload;
        },
        setConsoleStorage(state, action) {
            let payload = action.payload;
            state.consoleStorage.push(payload);
        }
    },
});

export const contactSliceAction = contactSlice.actions;
export default contactSlice.reducer;